import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';

const NotFoundPage = () => {
  return (
    <MainLayout skipNewsletter={true}>
      <div className="max-w-screen-xl mx-auto px-4">
        <main className="mt-4">
          {/* 404 Section */}
          <section className="mb-8">
            <div className="bg-white rounded-lg shadow-md p-8 md:p-12 text-center">
              {/* Large 404 */}
              <div className="mb-8">
                <h1 className="text-8xl md:text-9xl font-bold text-green-700 opacity-20 mb-4">404</h1>
                <div className="bg-green-100 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
              </div>

              {/* Error Message */}
              <div className="mb-8">
                <h2 className="text-3xl md:text-4xl font-bold text-green-800 mb-4">
                  Страницата не е намерена
                </h2>
                <p className="text-lg text-gray-600 mb-6 max-w-2xl mx-auto">
                  Съжаляваме, но страницата, която търсите, не съществува или е била преместена. 
                  Може би е време да се върнете към нашите екологични инициативи?
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
                <Link 
                  to="/" 
                  className="inline-flex items-center bg-green-700 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                  Към началната страница
                </Link>
              </div>
            </div>
          </section>

        </main>
      </div>
    </MainLayout>
  );
};

export default NotFoundPage; 